module.exports = vendor_bfd0b7f6066a2175278a;